module.exports = __webpack_public_path__ + "img/quests-logo.54b4d122.svg";